export const getApartmentStatus = (apartmentsStatus, apartmentId) => {
  let className = ''
  const apartment = apartmentsStatus.find(
    apartment => apartment.id === apartmentId,
  )

  if (apartment) {
    if (apartment.status === 'sold') {
      return (className = 'sold')
    }
    if (apartment.status === 'reserved') {
      return (className = 'reserved')
    }
  }

  return className
}

export const formatApartmentName = name => {
  let formattedName = ''

  if (name.includes('.')) {
    formattedName = name.split('.')[0]
    return formattedName
  }
  formattedName = name

  return formattedName
}

export const renderApartmentArea = (
  floor,
  name,
  area,
  changeView,
  setElementOnHover,
  sceneName,
  elementOnHover,
  apartments,
) => {
  const currentSceneName =
    floor < 10 ? `scene_0${floor}krs_${name}` : `scene_${floor}krs_${name}`

  return (
    <g
      key={name}
      onClick={() => changeView(floor, name)}
      onMouseOver={() => setElementOnHover(name)}
      onMouseLeave={() => setElementOnHover('')}
    >
      {!!area.points ? (
        <polygon
          id={name}
          className={`${area.className} ${
            sceneName === currentSceneName
              ? 'active-apt'
              : elementOnHover === name
              ? 'on-hover'
              : ''
          } ${getApartmentStatus(apartments, name)}`}
          points={area.points}
        />
      ) : (
        <rect
          key={name}
          id={name}
          className={`${area.className} ${
            sceneName === currentSceneName
              ? 'active-apt'
              : elementOnHover === name
              ? 'on-hover'
              : ''
          }`}
          x={area.x}
          y={area.y}
          width={area.width}
          height={area.height}
        />
      )}
    </g>
  )
}

export const renderViewCone = (name, viewCone, hLookAt, apartmentNumber) => {
  return (
    <g key={name} id={name} data-name={name} style={{ pointerEvents: 'none' }}>
      {name === apartmentNumber && (
        <>
          <path
            id={`cone-${name}`}
            data-name="cone"
            className={viewCone.className}
            d={viewCone.pathData}
            transform={`rotate(${hLookAt} ${viewCone.cx} ${viewCone.cy})`}
          />
          <circle
            id={`location-${name}`}
            data-name="location"
            className={viewCone.circleClassName}
            cx={`${viewCone.cx}`}
            cy={`${viewCone.cy}`}
            r="1.6046"
          />
        </>
      )}
    </g>
  )
}

export const renderApartmentLabel = (
  floor,
  name,
  namePaths,
  changeView,
  setElementOnHover,
  apartments,
) => {
  return (
    <g
      key={name}
      id={name}
      data-name={name}
      onClick={() => changeView(floor, name)}
      onMouseOver={() => setElementOnHover(name)}
      onMouseLeave={() => setElementOnHover('')}
      className={`${getApartmentStatus(apartments, name)}`}
    >
      {namePaths.map(({ className, d }, index) => (
        <path key={index} className={className} d={d} />
      ))}
    </g>
  )
}
